import { Add, GridView } from "@mui/icons-material";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, Outlet, useLocation } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";
import ModalContainer from "../../Components/Modal/ModalContainer";
import { ButtonTable } from "../../Layouts/ButtonsControlled";
import { createModel } from "../../Redux/modalSlice";
import CreateUtility from "../UtilityProviders/CreateUtility";

export default function Vendors() {
    const dispatch = useDispatch();
    const location = useLocation();
    const path = location.pathname.split("/")[2];

    return (
        <>
            <ModalContainer>
                <CreateUtility />
            </ModalContainer>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span> {path} </span>
                </div>
                <Link to="/dashboard/vendors/create">
                    <ButtonTable startIcon={<Add />}>New</ButtonTable>
                </Link>
            </HeaderTable>
            <Outlet />
        </>
    );
}
